import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'superUser/:superUserId(/:edit)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/SuperUserViewContainer',
      './modules/SuperUserView'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const SuperUserView = require('./containers/SuperUserViewContainer').default
      const actions = require('./modules/SuperUserView')
      const reducer = require('./modules/SuperUserView').default


      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'superUserView', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchSuperUserById(nextState.params.superUserId, nextState.params.edit)) // API Call for fetching super user by ID API
      store.dispatch(actions.fetchGroupTeams()) // API Call for fetching group teams

      /*  Return getComponent   */
      cb(null, SuperUserView)

    /* Webpack named bundle   */
    }, 'superUserView')
  }
})



// WEBPACK FOOTER //
// ./src/routes/SuperUserView/index.js